export const dataFormCertificates = {
  fileName: "",
  productName: "",
  typeFile: null,
};

export const LicenceKeys = {
  key: "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3NjI5MDU1OTksImp0aSI6IjkwMmM3NzQyLWFhOWQtNGZkNi04ZWJhLTY4ZmYwMDkxZDQwMSIsInVzYWdlRW5kcG9pbnQiOiJodHRwczovL3Byb3h5LWV2ZW50LmNrZWRpdG9yLmNvbSIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsiY2xvdWQiLCJkcnVwYWwiLCJzaCJdLCJ3aGl0ZUxhYmVsIjp0cnVlLCJsaWNlbnNlVHlwZSI6InRyaWFsIiwiZmVhdHVyZXMiOlsiKiJdLCJ2YyI6IjVkY2NmNzU0In0.z-efySDohUw38hQtZu7IMnX5tTlayWGS4HJfJafbKdvSzjm01F2okeyVAd8wWsbuQp-voNfYtbl7CNk6ASiyMQ",
};

export const CertificateType = [
  {
    id: "TEMPLATE",
    name: "Template",
  },
  {
    id: "ATTACHMENT",
    name: "Attachment",
  },
  {
    id: "QUICK_PRINT",
    name: "QuickPrint",
  },
];

export const mergeFieldsDataII = [
  {
    definitions: [
      {
        id: "name",
        label: "Nombre",
      },
      {
        id: "birthdate",
        label: "Fecha de nacimiento",
      },
    ],
    groupId: "guest",
    groupLabel: "Informacion del cliente",
  },
  {
    definitions: [
      {
        id: "providerName",
        label: "Provider name",
      },
      {
        id: "providerAddress",
        label: "Provider address",
      },
    ],
    groupId: "InsuranceInfo",
    groupLabel: "Información del seguro",
  },
];

interface Type {
  id: string;
  name: string;
}

export interface DataForm {
  fileName: string;
  productName: string;
  typeFile?: Type | null;
}
